<template>
  <SoPageWithHeader title="Onboarding">
    <SoTabs>
      <SoTab title="All Registrations">
        <SoContainer fluid>
          <OpsEnrolmentsListTable :segment="EnrolmentSegment.ALL" />
        </SoContainer>
      </SoTab>
      <SoTab title="Junifer Rejections">
        <SoContainer fluid>
          <OpsEnrolmentsListTable :segment="EnrolmentSegment.JUNIFER_ERRORS" />
        </SoContainer>
      </SoTab>
      <SoTab title="Other Errors">
        <SoContainer fluid>
          <OpsEnrolmentsListTable
            :segment="EnrolmentSegment.NON_JUNIFER_ERRORS"
          />
        </SoContainer>
      </SoTab>
    </SoTabs>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoContainer from "@/components/SoContainer.vue"
  import OpsEnrolmentsListTable from "@/views/operations/enrolments/components/OpsEnrolmentsListTable.vue"

  import SoTab from "@/components/tabs/SoTab.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import { defineComponent } from "vue"
  import { EnrolmentSegment } from "@/types/Enrolment"

  export default defineComponent({
    components: {
      OpsEnrolmentsListTable,
      SoTab,
      SoTabs,
      SoContainer,
      SoPageWithHeader,
    },
    data: () => ({
      EnrolmentSegment,
    }),
  })
</script>
